import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-page403',
  templateUrl: './page403.component.html',
  styleUrls: ['./page403.component.scss']
})
export class Page403Component implements OnInit {

  constructor( private route: ActivatedRoute, private router: Router) { }
  // Store the Url
  returnUrl = '';

  ngOnInit(): void {

    // Get and Store the Url from Params
    this.returnUrl = this.route.snapshot.queryParams.returnUrl;
  }

  // This Method will redirect the user to Previous Url/Page
  redirectTo() {
    this.router.navigateByUrl(this.returnUrl);

    // This will Redirect the User Using the Location Function i.e import { Location } from '@angular/common'
    // this.location.back();
  }

}
